import SiHaDocumentationStatusResourceModel from '../../generated/types/model/resource/SiHaDocumentationStatusResourceModel';

export default class SiHaDocumentationStatusResourceViewModel extends SiHaDocumentationStatusResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
